import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleArrowLeft,
  faCircleArrowRight,
  faChartSimple,
  faWarehouse,
  faChartLine,
  faSackDollar,
  faTruck,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import Logo from "../../assets/images/logograysimple.svg";
import useAuth from "../../hooks/useAuth";

import "./Nav.css";

const Nav = () => {
  const [showNav, setShowNav] = useState(false);

  const showHideNav = () => {
    setShowNav((prev) => !prev);
  };

  const { auth } = useAuth();

  return (
    <div className={showNav ? "Nav expandNav" : "Nav collapseNav"}>
      <div className='NavCollapseIconSection'>
        {showNav ? (
          <FontAwesomeIcon icon={faCircleArrowLeft} onClick={showHideNav} className='NavCollapseIcon' />
        ) : (
          <FontAwesomeIcon
            icon={faCircleArrowRight}
            onClick={showHideNav}
            className={showNav ? "NavCollapseIcon" : "NavCollapseIcon IconAbsolutePos"}
          />
        )}
      </div>
      {/* {showNav ? ( */}
      <div className='navcontainer'>
        <div className={showNav ? "NavItemsLarge" : "NavItems-collapsed"}>
          <NavLink className={showNav ? "toplink" : "toplink-collapsed"} to='/'>
            {showNav ? "Dashboard" : <FontAwesomeIcon icon={faChartSimple} style={{ fontSize: "20px" }} />}
          </NavLink>
          <NavLink className={showNav ? "toplink" : "toplink-collapsed"} to='/positions'>
            {showNav ? "Positions" : <FontAwesomeIcon icon={faWarehouse} style={{ fontSize: "20px" }} />}
            <div className='submenu'>
              <NavLink className='reportlink' to='/positions/reportusa'>
                Position Report USA
              </NavLink>
              <NavLink
                className='reportlink'
                style={{ borderBottom: "1px dashed var(--lightpurple)" }}
                to='/positions/reportspain'
              >
                Position Report Spain
              </NavLink>
              <NavLink to='/positions/supplier'>Add Supplier Position</NavLink>
              <NavLink to='/positions/spain'>Add Spain Position</NavLink>
              <NavLink to='/positions/usa'>Add USA Position</NavLink>
              <NavLink to='/positions/plant'>Add Plant Position</NavLink>
            </div>
          </NavLink>
          <NavLink className={showNav ? "toplink" : "toplink-collapsed"} to='/qs'>
            {showNav ? "Quotes" : <FontAwesomeIcon icon={faSackDollar} style={{ fontSize: "20px" }} />}
            <div className='submenu'>
              <NavLink to='/qs/usa'>US Distribution Quotes</NavLink>
              <NavLink to='/qs/spain'>Spain Distribution Quotes</NavLink>
            </div>
          </NavLink>
          <NavLink className={showNav ? "toplink" : "toplink-collapsed"} to='/logistics'>
            {showNav ? "Logistics" : <FontAwesomeIcon icon={faTruck} style={{ fontSize: "20px" }} />}
            <div className='submenu'>
              <NavLink style={{ borderBottom: "1px dashed var(--purple)" }} to='/logistics/inprogress'>
                In Progress
              </NavLink>
            </div>
          </NavLink>
          {auth.role === 2020 && (
            <NavLink className={showNav ? "toplink" : "toplink-collapsed"} to='/admin'>
              {showNav ? "Admin" : <FontAwesomeIcon icon={faUserShield} style={{ fontSize: "20px" }} />}
              {/* <NavLink to='/'>Home</NavLink> */}
              <div className='submenu'>
                <NavLink to='/admin/products'>Products</NavLink>
                <NavLink to='/admin/customers'>Customers</NavLink>
                <NavLink to='/admin/suppliers'>Suppliers</NavLink>
                <NavLink to='/admin/users'>Users</NavLink>
              </div>
            </NavLink>
          )}
        </div>
        <img src={Logo} className='navlogo' />
      </div>
      {/* ) : (
        ""
      )} */}
    </div>
  );
};

export default Nav;
